import { getRole } from "../utils/jwtService";
import { Navigate } from "react-router-dom";
import { IPrivateRouteProps } from "types/common/IPrivateRouteProps";

export function PrivateRoute({ children, roles }: IPrivateRouteProps) {
  const role = getRole();
  const token = localStorage.getItem("Access-token");
  console.log(role);
  return token?.length && role === roles ? (
    children
  ) : (
    <Navigate to="/auth/signin" replace />
  );
}
